"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceRegions() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const regions = [{
    label: "[ DADE COUNTY ]",
    heading: "Miami-Dade Region",
    response: "[ AVG. RESPONSE: 45 MIN ]",
    neighborhoods: ["Miami Beach", "Coral Gables", "Brickell", "Coconut Grove", "Aventura", "Key Biscayne", "Doral", "Homestead", "Kendall", "Pinecrest"]
  }, {
    label: "[ BROWARD COUNTY ]",
    heading: "Broward Region",
    response: "[ AVG. RESPONSE: 40 MIN ]",
    neighborhoods: ["Fort Lauderdale", "Hollywood", "Pembroke Pines", "Coral Springs", "Plantation", "Davie", "Miramar", "Weston", "Sunrise", "Deerfield Beach"]
  }, {
    label: "[ PALM BEACH ]",
    heading: "West Palm Region",
    response: "[ AVG. RESPONSE: 55 MIN ]",
    neighborhoods: ["West Palm Beach", "Boca Raton", "Delray Beach", "Boynton Beach", "Jupiter", "Wellington", "Palm Beach Gardens", "Lake Worth", "Royal Palm Beach", "Greenacres"]
  }];
  return <section data-section-id="859" id="our-service-regions" className="bg-background text-foreground py-24 md:py-32">
      <div className="max-w-[1440px] mx-auto px-[5vw]">
        {}
        <div ref={headerRef} className={`max-w-3xl mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs tracking-widest text-[var(--primary)] mb-6">
            [ SERVICE AREAS ]
          </p>
          <h2 className="font-default text-4xl md:text-6xl font-bold tracking-tighter leading-[1.1] text-foreground mb-6">
            Three counties.{" "}
            <em className="text-[var(--primary)] not-italic font-default italic">
              One standard of clinical precision.
            </em>
          </h2>
          <p className="text-muted-foreground text-xl leading-relaxed max-w-2xl font-default">
            MYB Services provides certified environmental testing and mold inspection across Dade, Broward, and West Palm counties. We bring 26 years of expertise to your doorstep.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {regions.map((region, i) => {
          const half = Math.ceil(region.neighborhoods.length / 2);
          const colA = region.neighborhoods.slice(0, half);
          const colB = region.neighborhoods.slice(half);
          return <div key={region.heading} data-index={i} className="group relative bg-card border border-border rounded-lg p-8 flex flex-col transition-all duration-300 hover:shadow-lg hover:-translate-y-1 overflow-hidden">
                {}
                <p className="font-mono text-xs tracking-widest text-[var(--primary)] mb-4">
                  {region.label}
                </p>

                {}
                <h3 className="font-default text-2xl font-semibold text-foreground mb-5 leading-tight">
                  {region.heading}
                </h3>

                {}
                <div className="h-px w-full bg-border mb-6" />

                {}
                <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 mb-8 flex-1">
                  {colA.map((name, idx) => <Link key={`a-${idx}`} to="/ServicesPage" className="text-[15px] text-foreground hover:text-[var(--primary)] hover:underline underline-offset-4 transition-colors font-default">
                      {name}
                    </Link>)}
                  {colB.map((name, idx) => <Link key={`b-${idx}`} to="/ServicesPage" className="text-[15px] text-foreground hover:text-[var(--primary)] hover:underline underline-offset-4 transition-colors font-default">
                      {name}
                    </Link>)}
                </div>

                {}
                <div className="flex items-center justify-between pt-4 border-t border-border">
                  <span className="font-mono text-[10px] md:text-xs tracking-widest text-muted-foreground">
                    {region.response}
                  </span>
                  <Button asChild variant="ghost" size="sm" className="text-foreground hover:text-[var(--primary)] hover:bg-transparent px-0 h-auto font-default">
                    <Link to="/ContactPage" className="inline-flex items-center gap-1.5 text-sm">
                      Request Inspection
                      <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
                    </Link>
                  </Button>
                </div>

                {}
                <span className="absolute bottom-0 left-0 h-px w-0 bg-[var(--primary)] transition-all duration-500 ease-out group-hover:w-full" />
              </div>;
        })}
        </div>

        {}
        <div className="mt-16 flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-10 border-t border-border">
          <p className="font-mono text-xs tracking-widest text-muted-foreground">
            [ NEED IMMEDIATE ASSISTANCE? CALL OUR CLINICAL TEAM DIRECTLY. ]
          </p>
          <Button asChild variant="outline" className="border-[var(--primary)] text-[var(--primary)] hover:bg-[var(--primary)] hover:text-white rounded-lg font-default">
            <Link to="tel:(561) 560-6653" className="inline-flex items-center gap-2">
              (561) 560-MOLD (6653)
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}